module.exports = __webpack_public_path__ + "static/media/bacteria_fish.9b89ba37.png";